import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ZohoService {

  constructor(private http: HttpClient) { }

  /**
   * Send Email Notification
   * @returns  
   */
  public sendEmail(params: any) {
    return this.http.post(`${environment.API_BASE_URL}sent-email`, params);
  }

}
